export const defaultPassword = "0000";
